const actionTypes = {
  SET_PRICES: '@MYYOLA/PRODUCTS/SET_PRICES',
  SET_BILLING_PROFILES: '@MYYOLA/PRODUCTS/SET_BILLING_PROFILES',
};

export default actionTypes;
